import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _class2, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { CnamApiError } from "cnam/utils/cnam-api-errors";
import Ember from "ember";
import { task } from "ember-concurrency";
import ControlTower from "wise-control-tower";
import DmpRetrievalContext from "./dmp-retrieval-context";
class DmpBulkDownloadDmpRetrievalContext extends DmpRetrievalContext {
  constructor(cnamAdapterName, patient, authenticationContext, dmpAdapter, insiAdapter, dmpBulkDownloadSessionStartedJournalEvent, store, fetcher) {
    super(cnamAdapterName, patient, authenticationContext, dmpAdapter, insiAdapter, store, fetcher, () => {
      dmpBulkDownloadSessionStartedJournalEvent.cnamProcessStartedJournalEvents.push(this.cnamProcessStartedJournalEvent);
      dmpBulkDownloadSessionStartedJournalEvent.save();
    });
    // We disable secret connection handling for bulk download
    // This is a consequence of DMPConnectJS secret connection handling :
    // Setting a secret connection with DMPConnectJS requires a function call
    // stating that all the future calls will be done with a secret
    // connection. As multiple calls may be done concurrently, it would
    // require us to ensure that "setting a secret connection + an actual TD call"
    // is atomically done. It would require another refactoring, so we'll see
    // in a future release.

    // We also disable the practice location selection
    // in case the currently selected isn't vaid, because we can't
    // show an intermediate step for the moment.

    // We disable the retrieval of non-HR
    // documents, as it's too long
    // and too much error prone.
    _defineProperty(this, "transitionTo", async row => {
      this.loading = true;
      await this._transitionTo(row);
      this.loading = false;
    });
    _defineProperty(this, "_transitionTo", async row => {
      try {
        await this.currentState?.run();
        this.currentState = await this.calculateCurrentState();
        this.modifyStatus(row);
        if (this.currentState && !this.currentState?.requiresUserAction && !this.successKey) {
          await this._transitionTo(row);
        }
      } catch (error) {
        if (!Ember.testing) console.error("Error in context", error);
        if (error instanceof CnamApiError && !Ember.testing) {
          console.error("Details", error.error);
          ControlTower.captureException(error);
        }
        this.lastError = error;
        this.modifyStatus(row);
      }
    });
    this.states = this.states.filter(state => state.key != "set-secret-connection" && state.key != "select-another-practice-location-with-billing-number" && state.key != "retrieve-and-save-documents");
    const saveIdentityState = this.states.find(state => state.key == "save-identity");
    if (saveIdentityState) {
      saveIdentityState.requiresUserAction = false;
    }

    // This is needed for the DMP retrieval state machine
    this.nonHrRetrieved = true;
    this.nonHrProcessEnded = true;
  }
  modifyStatus(row) {
    if (!row) return;
    if (row.context.lastError) {
      row.status = "failure";
    } else if (row.context.successKey) {
      row.status = "successful";
    } else {
      switch (row.context.currentState.key) {
        case "set-secret-connection":
          row.status = "secret-connection-to-set";
          break;
        case "ins-qualification-needed":
          row.status = "ins-not-qualified";
          break;
        case "authorize-medic":
          row.status = "unauthorized-medic-no";
          break;
        case "retrieve-and-save-latest-reimbursement-document":
          row.status = "retrieving";
          break;
      }
    }
  }
}
export let BulkDownloadRow = (_class = class BulkDownloadRow {
  constructor(patient, status, context, selected = false) {
    _initializerDefineProperty(this, "status", _descriptor, this);
    _initializerDefineProperty(this, "context", _descriptor2, this);
    _initializerDefineProperty(this, "selected", _descriptor3, this);
    this.patient = patient;
    this.status = status;
    this.context = context;
    this.selected = selected;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "context", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let DmpBulkDownloadContext = (_class2 = class DmpBulkDownloadContext {
  constructor(cnamAdapterName, eligibleSortedPatientsToTreat, notEligibleButEnrolledPatientsToTreat, insiAdapter, dmpAdapter, authenticationContext, store, fetcher, dmpBulkDownloadSessionStartedJournalEvent) {
    _initializerDefineProperty(this, "bulkDownloadRows", _descriptor4, this);
    _defineProperty(this, "filterGivenStatus", (patients, status) => {
      return patients.filter(patient => patient.status === status);
    });
    _defineProperty(this, "treatInsQualifications", _buildTask(() => ({
      context: this,
      generator: function* () {
        for (const insNotQualifiedInsPatient of this.insNotQualifiedInsPatients) {
          if (insNotQualifiedInsPatient.context.insDocumentIsQualifying) {
            yield insNotQualifiedInsPatient.context.transitionTo(insNotQualifiedInsPatient);
          } else {
            insNotQualifiedInsPatient.status = "ins-qualification-failed";
          }
        }
      }
    }), null, "treatInsQualifications", null));
    _defineProperty(this, "treatAuthorizeMedics", _buildTask(() => ({
      context: this,
      generator: function* () {
        for (const unauthorizedMedicToRejectPatient of this.unauthorizedMedicToRejectPatients) {
          unauthorizedMedicToRejectPatient.status = "unauthorized-medic-reject";
        }
        for (const unauthorizedMedicToTreatPatient of this.unauthorizedMedicToTreatPatients) {
          unauthorizedMedicToTreatPatient.context.shouldAuthorizeMedicToAccessPatientDmp = true;
          yield unauthorizedMedicToTreatPatient.context.transitionTo(unauthorizedMedicToTreatPatient);
        }
      }
    }), null, "treatAuthorizeMedics", null));
    _defineProperty(this, "setSecretConnections", _buildTask(() => ({
      context: this,
      generator: function* () {
        for (const secretConnectionToSetPatient of this.secretConnectionToSetPatients) {
          yield secretConnectionToSetPatient.context.transitionTo(secretConnectionToSetPatient);
        }
      }
    }), null, "setSecretConnections", null));
    _defineProperty(this, "retrievePatientsDmp", _buildTask(() => ({
      context: this,
      generator: function* () {
        for (const unselectedPatientToTreat of this.unselectedPatientsToTreat) {
          unselectedPatientToTreat.status = "unselected-to-treat";
        }
        for (const selectedPatientToTreat of this.selectedPatientsToTreat) {
          selectedPatientToTreat.status = "retrieving";
          yield selectedPatientToTreat.context.transitionTo(selectedPatientToTreat);
        }
      }
    }), null, "retrievePatientsDmp", null));
    this.cnamAdapterName = cnamAdapterName;
    this.insiAdapter = insiAdapter;
    this.dmpAdapter = dmpAdapter;
    this.authenticationContext = authenticationContext;
    this.store = store;
    this.fetcher = fetcher;
    eligibleSortedPatientsToTreat.forEach((patient, index) => {
      this.bulkDownloadRows.push(new BulkDownloadRow(patient, "to-treat", new DmpBulkDownloadDmpRetrievalContext(this.cnamAdapterName, patient, this.authenticationContext, this.dmpAdapter, this.insiAdapter, dmpBulkDownloadSessionStartedJournalEvent, this.store, this.fetcher), index < this.dmpAdapter.remainingRate));
    });

    /** Only enrolled patients are shown */
    notEligibleButEnrolledPatientsToTreat.forEach(patient => {
      this.bulkDownloadRows.push(new BulkDownloadRow(patient, "ineligible", new DmpBulkDownloadDmpRetrievalContext(this.cnamAdapterName, patient, this.authenticationContext, this.dmpAdapter, this.insiAdapter, dmpBulkDownloadSessionStartedJournalEvent, this.store, this.fetcher)));
    });
  }
  reset() {
    this.bulkDownloadRows = [];
  }
  get patientsTreating() {
    return this.filterGivenStatus(this.bulkDownloadRows, "retrieving");
  }
  get patientsToTreat() {
    return this.filterGivenStatus(this.bulkDownloadRows, "to-treat");
  }
  get selectedPatientsToTreat() {
    return this.patientsToTreat.filter(row => row.selected);
  }
  get unselectedPatientsToTreat() {
    return this.patientsToTreat.filter(row => !row.selected);
  }
  get unselectedPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "unselected-to-treat");
  }
  get hourlyRateOnError() {
    return this.selectedPatientsToTreat.length > this.dmpAdapter.hourlyRemainingRate;
  }
  get dailyRateOnError() {
    return this.selectedPatientsToTreat.length > this.dmpAdapter.dailyRemainingRate;
  }
  get successfulPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "successful");
  }
  get unauthorizedMedicToTreatPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "unauthorized-medic-yes");
  }
  get unauthorizedMedicToRejectPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "unauthorized-medic-no");
  }
  get unauthorizedMedicToDecidePatients() {
    return [...this.unauthorizedMedicToTreatPatients, ...this.unauthorizedMedicToRejectPatients].toSorted(this.sortOnFirstAndLastName);
  }
  get unauthorizedMedicRejectedPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "unauthorized-medic-reject");
  }
  get insNotQualifiedInsPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "ins-not-qualified");
  }
  get insQualificationFailedPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "ins-qualification-failed");
  }
  get secretConnectionToSetPatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "secret-connection-to-set");
  }
  get ineligiblePatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "ineligible");
  }
  get failurePatients() {
    return this.filterGivenStatus(this.bulkDownloadRows, "failure");
  }
  sortOnFirstAndLastName(a, b) {
    const aa = a.patient.firstName + ", " + a.patient.lastName,
      bb = b.patient.firstName + ", " + b.patient.lastName;
    if (aa > bb) return 1;else if (aa < bb) return -1;
    return 0;
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "bulkDownloadRows", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "reset"), _class2.prototype), _class2);
export { DmpBulkDownloadContext as default };